import * as React from "react";
import { Subscriber } from "src/share/components/RealtimeData/Subscriber";
import environmentHelper from "src/share/utils/environmentHelper";

interface IQueueStatus {
  processing: number,
  waiting: number
}
interface IRecognitionStatusProps {
  mode: 'rek' | 'etl'
}
export const RealtimeServicesStatus = ({ mode }: IRecognitionStatusProps) => {
  const isRek = mode === 'rek';
  const serverUrl = isRek ? environmentHelper.getRecognitionURL() : environmentHelper.getETLURL();
  return (
    <div className='col-12 white-background col'>
      <Subscriber<IQueueStatus> serverUrl={serverUrl} path={'/queueStatus'} event={'queue-changed'}>
        {
          (data) => {
            return (
              <div className="realTimeInformation">
                <h5>{isRek ? "Images" : "ETL"} queue real-time status:</h5>
                <p>Processing: {data.processing || 0}</p>
                <p>Waiting: {data.waiting || 0}</p>
              </div>
            )
          }
        }
      </Subscriber>
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/modules/UserSettings/ServicesStatus/component/Status.tsx